import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OnsiteProgram } from 'globals/store/onsite.data';
import { Wrapper } from 'src/app/components/wrapper.component';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { DialogTitleComponent } from '../program/dialog-title';
import { ViewSetupViewComponent } from './onsite.dialog.viewSetup.view.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'view-setup-dialog',
    template: `
<div class="view_detail_dialog joi-dialog">
	<icon class="close" aria-label="Close" (click)="dialogRef.close()" matIcon="close"></icon>
	<dialog-title [title]="'Setup Information'" [backgroundColor]="'var(--secondary)'" ></dialog-title>
	<div mat-dialog-content>
    <view-setup-view [setupId]="data.setupId" [programId]="data.program.scheduleId"></view-setup-view>
  </div>
</div>
`,
    styleUrls: [`onsite.page.scss`],
    standalone: true,
    imports: [IconComponent, DialogTitleComponent, ViewSetupViewComponent, CommonModule],
})
export class ViewSetupDialogComponent extends Wrapper<ViewSetupDialogComponent> implements OnDestroy {

	constructor(public dialogRef: MatDialogRef<ViewSetupDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: ViewSetupDialogData) {
    super()
	}

}

export interface ViewSetupDialogData {
  date: string | Date,
  program: OnsiteProgram,
  setupId: string
  type: 'access' | 'clear'
}

